<template>
    <div class="checkout-cart mb-4">
          <div class="row">
              <div class="col-md-12 your-cart">
                  <div class="cart-details">
                    <div v-if="isShow">
                      <error-alert
                          :variant="orderResponse.variant"
                          :msg="orderResponse.message"
                          :errorMsg="orderResponse.errmsg"
                      />
                    </div>
                      <div class="row">
                      <div class="col">
                        <h2 :class="[goToUserInformationBtnDisplay ? 'float-left' : '']" >{{ $t("FIND SERVICE POINT") }}</h2>
                      </div>
                      <div class="col text-right">
                        <b-button
                            variant="dark"
                            @click="goToUserInformation('Cart')"
                            class="mb-2"
                            v-if="goToUserInformationBtnDisplay && !proceedLoading"
                        ><i class="fa fa-angle-double-right mr-2"></i
                        >{{ $t("Continue") }}</b-button
                        >
                        <span class="px-3" v-if="proceedLoading"><span class="fa fa-spinner fa-spin"></span> {{ $t('Updating details') }} </span>
                      </div>

                      </div>
                          <div class="my-appointment">
                          <div class="row">
                              <div class="col-9 col-sm-10 col-md-10 mb-2 pr-0">
                                  <!-- <input type="text" class="location-input" value="" placeholder="Zip code"> -->
                                  <vue-google-autocomplete
                                      id="map"
                                      classname="location-input"
                                      :placeholder="$t('Zip code')"
                                      v-on:placechanged="getAddressData"
                                      :country="['fi']"
                                      v-model="address"
                                      required="true"
                                      types="geocode"
                                      ref="autocomplete"
                                      @keyup="clearSearchedServicePoint($event)"
                                  >
                                  </vue-google-autocomplete>
                              </div>
                              <div class="col-3 col-sm-2 col-md-2 mb-2">
                                  <button class="btn btn-location" @click="getDealerServices();"><i class="fas fa-search"></i> {{ $t("Find") }}</button>
                              </div>
                              <!-- <div class="col-8 col-sm-9 col-md-9" v-if="strAddress != '' && isVisibleSearchTag">
                                  <div style="border-radius: 25px;background-color: #343A40; width: fit-content;display:inline-block;">
                                      <span style="color: #FFF; font-size: 14px;" class="ml-2 mr-1">{{strAddress}}</span>
                                      <a href="#" @click="resetSearch()" onMouseOver="this.style.color='#ff3333'" onMouseOut="this.style.color='#e60000'" style="color:#e60000"><i class="fa fa-times ml-1 mr-2" aria-hidden="true"></i></a>
                                  </div>
                              </div> -->
                              <div class="col-md-12 mb-3">
                                  <b-row class="mt-2">
                                      <b-col md="7" lg="8">
                                          {{ $t("Enter zipcode or city to search nearby service points") }}
                                      </b-col>
                                      <b-col md="5" lg="4">
                                          <div class="sort-by-dealers">
                                              <span class="mr-2">{{ $t('SortBy') }}: </span>
                                              <b-form-select v-model="sortSelected"  @change="sortDealers($event)" class="custom-select">
                                                  <option :value="{ sortBy: 'price', sortDirection: 'Asc' }">{{ $t('Service Cost') }}: &#8607;</option>
                                                  <!-- <option :value="{ sortBy: 'price', sortDirection: 'Desc' }">{{ $t('Service Cost:') }} &#8609;</option> -->
                                                  <option :value="{ sortBy: 'distance_km', sortDirection: 'Asc' }">{{ $t('Distance to Location') }}: &#8607;</option>
                                                  <!-- <option :value="{ sortBy: 'distance_km', sortDirection: 'Desc' }">{{ $t('Distance to Location') }}: &#8609;</option> -->
                                                  <option :value="{ sortBy: 'company_name', sortDirection: 'Asc' }">{{ $t('Service Point Name') }}: &#8607;</option>
                                                  <!-- <option :value="{ sortBy: 'company_name', sortDirection: 'Desc' }">{{ $t('Service Point Name:') }} &#8609;</option> -->
                                              </b-form-select>
                                          </div>  
                                      </b-col>
                                  </b-row>
                              </div>
                          </div>
                          <!-- <b-row class="mt-2">
                              <b-col md="8" lg="9">
                                  <b-alert variant="warning" class="text-dark select-working-days" show>
                                      <b-form-group :label="$t('Select Working Days')" v-slot="{ ariaDescribedby }">
                                          <b-form-checkbox-group
                                          v-model="selectedWorkingDay"
                                          :aria-describedby="ariaDescribedby"
                                          >
                                              <b-form-checkbox :value="{id: 2, value: 'monday',sortBy: 'workingday', name: 'Monday'}">{{ $t('Monday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 3, value: 'tuesday',sortBy: 'workingday', name: 'Tuesday'}">{{ $t('Tuesday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 4, value: 'wednesday',sortBy: 'workingday', name: 'Wednesday'}">{{ $t('Wednesday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 5, value: 'thursday',sortBy: 'workingday', name: 'Thursday'}">{{ $t('Thursday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 6, value: 'friday',sortBy: 'workingday', name: 'Friday'}">{{ $t('Friday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 7, value: 'saturday',sortBy: 'workingday', name: 'Saturday'}">{{ $t('Saturday') }}</b-form-checkbox>
                                              <b-form-checkbox :value="{id: 1, value: 'sunday',sortBy: 'workingday', name: 'Sunday'}">{{ $t('Sunday') }}</b-form-checkbox>
                                          </b-form-checkbox-group>
                                      </b-form-group>
                                  </b-alert>
                              </b-col>
                              <b-col md="4" lg="3">
                                  <b-alert variant="" class="sort-by" show>
                                      <label>{{ $t('Sort By') }}</label>
                                      <b-form-select v-model="sortSelected"  @change="sortDealers($event)" class="custom-select">
                                          <option :value="{ sortBy: 'price', sortDirection: 'Asc' }">{{ $t('Service Cost') }}: &#8607;</option>
                                          <option :value="{ sortBy: 'price', sortDirection: 'Desc' }">{{ $t('Service Cost:') }} &#8609;</option>
                                          <option :value="{ sortBy: 'distance_km', sortDirection: 'Asc' }">{{ $t('Distance to Location') }}: &#8607;</option>
                                          <option :value="{ sortBy: 'distance_km', sortDirection: 'Desc' }">{{ $t('Distance to Location') }}: &#8609;</option>
                                          <option :value="{ sortBy: 'company_name', sortDirection: 'Asc' }">{{ $t('Service Point Name') }}: &#8607;</option>
                                          <option :value="{ sortBy: 'company_name', sortDirection: 'Desc' }">{{ $t('Service Point Name:') }} &#8609;</option>
                                      </b-form-select>
                                  </b-alert>
                              </b-col>
                          </b-row> -->
  
                          <div v-if="loading"><div class="loading"></div></div>
                          <div v-else-if="showServices && localDealersList.length && !loading">
                              <b-row>
                                  <b-col class="float-left"><h2>{{ $t("Suggested Service points") }}</h2></b-col>
                                  <b-col class="text-right" v-if="localDealersList.length == 1"> {{ $t("Available Service Points") }}: <b>{{ localDealersList.length }}</b></b-col>
                                  <b-col class="text-right" v-if="localDealersList.length > 1"> {{ $t("Available Service Points") }}: <b>{{ localDealersList.length }}</b></b-col>
                              </b-row>
                              <div v-for="(dealerservice, index) in localDealersList" :key="index" class="garage-list border" :ref="`dealer_card_${dealerservice.id}`">
                                  <div  class="d-flex align-items-start justify-content-between p-3 border-bottom flex-wrap flex-sm-wrap"
                                        :style="
                                            /*((appointmentCached) ? (appointmentCached.dealer_id == dealerservice.id) ? 'box-shadow: 0 0 5px 5px #DA9D27' : '' : '') ||*/
                                            ((selectedServicePoint !== null && selectedServicePoint.dealer_id == dealerservice.id) ? 'box-shadow: 0 0 5px 5px #DA9D27' : '')
                                               "
                                        :id="`dealer_card_${dealerservice.id}`"
                                  >
                                      <div class="mb-3 mb-md-0 w-40 w-40">
                                          <h4>{{ dealerservice.company_name }}</h4>
                                          <p>{{ dealerservice.address_line_1 }} {{ dealerservice.address_line_2 || ''}}</p>
                                          <p>{{ dealerservice.zipcode }}, {{ dealerservice.city }}</p>
                                          <p>{{ $t("Distance to location:") +' '+ distanceToLocation(dealerservice.distance_km) + ' km' }}</p>
                                          <p>{{ $t("Available On: ") }}   {{    showAvailableSlots(dealerservice)   }}</p>
                                      </div>
                                      <div class="mb-3 mb-md-0">
                                          <h4 class="mb-1">{{ $t("Services offered")}}</h4>
                                          <div v-if="dealerservice.services">
                                              <p class="mb-1" v-for="(service, key) in dealerservice.services" :key="key" style="border-bottom: 1px solid #ec971f">
                                                  {{ service.vehicle_type}} : {{ formatPrice(service.price) }} <br/>
                                                  <template v-if="service.is_price_per_quantity=='1'">
                                                      {{ service.service_name}} {{ rimSize(service.rim_size)}} - {{ formatPrice(serviceTotalCost(service)) }}
                                                  </template>
                                                  <template v-if="service.is_price_per_quantity=='0'">
                                                      {{ service.service_name}} {{ rimSize(service.rim_size)}} - {{ formatPrice(service.price) }}
                                                  </template>
                                              </p>
                                              <p>{{ $t('Service Cost Total') }}: {{ formatPrice(dealerServicesSums(dealerservice.services)) }}</p>
                                          </div>
                                      </div>
                                      <div class="d-flex flex-column bd-highlight mb-3 w-31">
                                          <div v-if="dealerservice.time_slots.length">{{ $t('Next Available On') }}</div>
                                          <div v-if="dealerservice.time_slots.length">{{ nextAvailableSlotDate(dealerservice) }}</div>
                                          <div class="pt-2" v-if="dealerservice.time_slots.length"><button  v-b-modal="'my-modal-'+dealerservice.dealer_id" @click="showAppointment(index, dealerservice)" class="text-uppercase bg-success pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn"  data-toggle="modal" data-target="#myModal">{{ $t("Make an appointment") }}</button></div>
                                          <div v-else>
                                            <h4>{{ $t('Appointment by phone') }} : </h4> <p>{{ $t('tel')}}. <span class="font-italic">{{dealerservice.contact_number}}</span></p>
                                            <div class="pt-2"><button @click="proceedOrderWithoutAppointment(dealerservice)" class="text-uppercase bg-success pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn btn-block">{{ $t("Confirm order") }}</button></div>
                                          </div>
                                      </div>
                                  </div>
                                  <b-modal class="modal" :hide-footer="true" title-tag='h4' header-text-variant='dark' title-class="text-uppercase" :title="$t('Select date & time')" name="modal" v-if="showModal" :id="'my-modal-'+dealerservice.dealer_id">
                                      <div v-if="dealerservice">
                                          <appointment-popup @goToError="goToError" @hidepopup="removeAppointmentPopup" :allowedTimes="updateAllowedTime(dealerservice)" :dealerService="dealerService" :availableDays="availableSlotDay(dealerService)" :localDealersList="localDealersList"></appointment-popup>
                                      </div>
                                  </b-modal>
                              </div>
                              <div class="modal loading" name="modal" v-show="showModal && !loadAppointments" id="loadModal">
                                  <div class="modal-dialog  modal-dialog-centered">
                                      <div class="modal-content">
                                          <div class="modal-header">
                                              <h4 class="modal-title text-uppercase">{{$t("Select date & time")}}</h4>
                                              <button type="button" class="close" data-dismiss="modal">&times;</button>
                                          </div>
                                          <div class="modal-body">
                                              <div class="loading"></div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div v-else-if="showServices && isShowEmptyDealerMessage">
                              <h2>{{ $t("Suggested Service points") }}</h2>
                              {{ $t("It seems there is no service point available for the selected location. Kindly contact us on Chat or customer service 0405529803 for further assistance.") }}
                          </div> 
                      </div> 
                  </div>
              </div>
          </div>
      </div>
  </template>
  <style>
  #inline{width:100%;height:auto;background-color:black;display:flex;} 
  .one,.two{width:50%;height:100px;background-color:green;margin:10px;} 
  .location-input{
      background: none;
  }
  .b-calendar-inner {
      width:330px !important;
  }
  .small {
      display:none;
  }
  .time-slots {
      border: 1px;
      padding: 1px;
      height: 270px;
      overflow-y: scroll;
      font-size: 0.5rem;
      width: 23%
  }
  .w-40 {
      width: 40%
  }
  .w-31 {
    width: 31%
  }
  .sort-by {
      padding-right: 0px;
      padding-left: 0px;
  }
  .select-working-days .form-group {
      margin-bottom: 0px;
  }
  .sort-by-dealers {
      float: right;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  @media only screen and (max-width: 767px) {
      .sort-by-dealers {
          margin-top: 5px;
          float: left;
          display: flex;
          align-items: center;
          justify-content: center;
      }
  }
  </style>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import AppointmentPopup from "../components/AppointmentPopup";
  import ErrorAlert from "./ErrorAlert";
  
  export default {
      name: "TabAppointments",
      props:{
          services:String,
          paymentStatus:String
      },
      components: {
          'vue-google-autocomplete': VueGoogleAutocomplete,
          'appointment-popup': AppointmentPopup,
          'error-alert' : ErrorAlert,
      },
      data() {
          return {
              errors:[],
              showModal:false,
              showServices:false,
              address: '',
              displayAddress: '',
              loadAppointments: false,
              disableProceed:false,
              dealerService:{},
              unavailableDays:[],
              sortBy: 'distance_km',
              sortDirection: 'Asc',
              sortSelected: {
                  sortBy: 'distance_km',
                  sortDirection: 'Asc',
              },
              selectedWorkingDay: [],
              localDealersList: [],
              tempAddress: null,
              isVisibleSearchTag: false,
              goToUserInformationBtnDisplay:false
          }
      },
      async created() {
          this.setShowEmptyDealerMessage(false);
          this.getHolidayList()
          if (this.selectedServicePoint === null) {
            if ("SearchedSelectedServicePoint" in localStorage) {
              this.setSelectedServicePoint(JSON.parse(localStorage.getItem("SearchedSelectedServicePoint")));
            } else if ("dealerservice" in localStorage) {
              this.setSelectedServicePoint(JSON.parse(localStorage.getItem("dealerservice")));
            }
          }
          /*if(this.getTempAddress && this.autoSearchedAsHome === false) {
              this.address = this.getTempAddress
              await this.getDealerServices()
          } else */if ("GoogleAddress" in localStorage) {
            const addressData = JSON.parse(localStorage.getItem("GoogleAddress"))
            const placeResultData  = JSON.parse(localStorage.getItem("GoogleSelectedPlace"))
            this.getAddressData(addressData, placeResultData)
            await this.getDealerServices(this.currentLang)
          } else if("setSearchedZipcode" in localStorage && "ctPlaceResultData" in localStorage) {
            const addressData = JSON.parse(localStorage.getItem("setSearchedZipcode"))
            const placeResultData  = JSON.parse(localStorage.getItem("ctPlaceResultData"))
            this.getAddressData(addressData, placeResultData)
            await this.getDealerServices(this.currentLang)
          }


          this.getAppointmentCached()
          if (this.strAddress != '' && this.$refs.autocomplete) {
              this.isVisibleSearchTag = true
          }
  
          if (this.paymentStatus == "failed") {
  
              if(localStorage.getItem("service")){
                  this.services =  localStorage.getItem('service').split(",");
              }
  
              this.setTempAddress(localStorage.getItem('setSearchedZipcode'))
  
              let params = "";
              params = localStorage.getItem('setDealerServiceApiParamsCached');
  
              this.setDealerServiceApiParamsCached(params);
  
              if(this.getTempAddress) {
                  this.address = this.getTempAddress
                  this.getDealerServices()
              }
  
              this.getAppointmentCached()
  
              this.setStrAddress(localStorage.getItem("tempAddress"))
  
              if (this.strAddress != '' && this.$refs.autocomplete) {
                  this.isVisibleSearchTag = true
              }
  
              // if (localStorage.getItem('tempAddress')) {
              //     this.$refs.autocomplete.update(localStorage.getItem('tempAddress'))
                  
              //     this.setStrAddress(localStorage.getItem('tempAddress'))
              // }
              
              // if (localStorage.getItem('tempAddress')) {
              //     // this.address = '{"postal_code":"04500","administrative_area_level_1":"Uusimaa","country":"Finland","latitude":60.5353935,"longitude":25.1182686}';
              //     this.address = localStorage.getItem('setSearchedZipcode');
  
              //     let params = "";
              //     params = localStorage.getItem('setDealerServiceApiParamsCached');
  
              //     this.setDealerServiceApiParamsCached(params);
  
              //     this.getDealerServices()
              // }
  
              // if (localStorage.getItem('tempAddress') != '' && this.$refs.autocomplete) {
              //     this.strAddress = localStorage.getItem('tempAddress')
              //     this.isVisibleSearchTag = true
              // }
  
              // this.address = localStorage.getItem("setSearchedZipcode");
              // this.setSearchedZipcode(this.address);
              // this.showServices = true;
  
              // let params = "";
              // params = localStorage.getItem('setDealerServiceApiParamsCached');
  
              // this.strAddress = localStorage.getItem('strAddress');
              // this.$refs.autocomplete.update(this.strAddress)
  
              // console.log(params);
  
              // this.fetchDealerServices(params)
              //         .then(response => {
              //             this.localDealersList = this.dealerServiceList
              //             // this.filterDealersByWorkingdays(this.selectedWorkingDay)
              //         })
              //         .catch(error => {
              //             reject(error);
              //         });
              // this.setDealerServiceApiParamsCached(params)
            this.resetError();
          }
  
          if(localStorage.getItem('dealerservice') && localStorage.getItem('appointment')) {
              this.goToUserInformationBtnDisplay = true;
  
              // // Set appointment for cache
              let appointment = JSON.parse(localStorage.getItem("appointment"));
  
              this.addAppointment(appointment)
  
              this.dealerService = JSON.parse(localStorage.getItem('dealerservice'));
          }
  
          // if (this.searchZipCode && this.strAddress) {
          //     this.searchedStatus = true
          //     this.address = this.searchZipCode
          //     this.getDealerServices(this.lang)
          // } else {
          //     this.address = ''
          // }
      },
      watch:{
          rimSizes: {
              immediate: true,
              handler:function(newVal,oldVal){
                  if(newVal && newVal.length > 0 && this.showServices) {
                      this.getDealerServices(this.currentLang)
                  } else if(newVal && newVal.length == 0) {
                      this.showServices = false
                      this.$router.push({
                          path: '/cart',
                          params: {}
                      })
                  }
              },
              deep:true
          },
          showServices:{
              immediate: true,
              handler(newValue) {
                  this.showServices = newValue
              }
          },
          showModal: {
              immediate:true,
              handler(newValue) {
                  this.showModal = newValue
              }
          },
          currentLang: {
              handler(newVal) {
                  if(this.getTempAddress) {
                      this.localDealersList = [];
                      this.address = this.getTempAddress
                      this.getDealerServices(newVal)
                  }
              }
          },
          dealerService: {
              immediate:true,
              deep:true,
              handler(newValue) {
                  this.dealerService = newValue
              }
          },
          unavailableDays: {
              immediate:true,
              deep:true,
              handler(newValue) {
                  this.unavailableDays = newValue
              }
          },
          allowedTimes: {
              immediate:true,
              deep:true,
              handler(newValue) {
                  this.allowedTimes = newValue
              }
          },
          selectedWorkingDay: {
              handler(newValue) {
                  this.filterDealersByWorkingdays(newValue);
              }
          }
      },
      mounted() {
          $('.form-control').removeAttr('readonly');
          if (this.getTempAddress && this.ctPlaceResultData && ("address" in localStorage || "GoogleAddress" in localStorage)) {
              this.$refs.autocomplete.update(this.ctPlaceResultData.formatted_address)
          }
      },
      computed: {
          ...mapGetters('app', ['currentLang']),
          ...mapGetters('dealerservices', ['loading', 'dealerServiceList', 'searchZipCode', 'strAddress', 'dealerServiceApiParamsCached', 'getTempAddress', 'ctPlaceResultData', 'isShowEmptyDealerMessage']),
          ...mapGetters('cart', ['rimSizes', 'cartId', 'cartProducts', 'cartDetails']),
          ...mapGetters('appointments', ['isShow', 'response', 'appointmentLoading', 'unavailableSlots', 'holidays', 'appointmentCached']),
          ...mapGetters('services', ['cartServiceLoading', 'cartServices', 'additionalServices']),
          ...mapGetters('order', ['proceedLoading', 'orderResponse', 'isShow']),
          ...mapGetters('search_dealer', ['selectedServicePoint']),
          rimSizesState:function(){
              return this.$store.state.rimSizes; // return the state value in `my_state`
          },
          cartProductsState:function(){
              return this.$store.state.cartProducts; // return the state value in `my_state`
          }
      },
      methods: {
          ...mapActions('dealerservices', ['fetchDealerServices', 'setSearchedZipcode', 'setStrAddress', 'setDealerServiceApiParamsCached', 'setTempAddress', 'setCtPlaceResultData', 'setShowEmptyDealerMessage']),
          ...mapActions('services', ['addServicesInCart']),
          ...mapActions('appointments', ['addAppointment', 'showError', 'resetError', 'getUnavailableSlotList', 'getHolidayList', 'getAppointmentCached']),
        ...mapActions('order', ['confirmOrderWithPaytrail', 'resetError']),
        ...mapActions('cart', ['getAllCartProducts']),
        ...mapActions('search_dealer', ['setSelectedServicePoint', 'setDealers']),
        ...mapActions('cart_right_sidebar', ['csSetName', 'csSetEmail', 'csSetPhone', 'csSetDate', 'csSetAddress', 'csSetCity', 'csSetTime', 'csSetDealerId', 'csSetTimeSlots', 'csSaveDealerToLocalStorage', 'csSetIsWithService']),
        async proceedOrderWithoutAppointment(dealerService) {
          var appointment_data = {
            dealer_id : dealerService.dealer_id,
            cart_id : this.cartId,
            service_ids : '',
            without_calendar : true
          }
          var dealerServices = dealerService.services;
          var selectedServices = 'service' in localStorage && localStorage.getItem('service') !== '' ? localStorage.getItem('service').split(",") : [];
          var finalServices = [];
          dealerServices.forEach((Service) => {
            if (selectedServices.includes(Service.id.toString())) {
              finalServices.push(Service.id.toString());
            }
          })
          appointment_data.service_ids = '['+finalServices.join([','])+']';
          this.csSetRightSidebarDealerData(appointment_data)
          // Set appointment for cache
          localStorage.setItem("appointment", JSON.stringify(appointment_data));
          await this.addAppointment(appointment_data).then(() => {
            this.$router.push({
              path: '/cart/user-info', params: {}, replace: true
            });
          }).catch(() => {

          }).finally(() => {

          });
          await this.getAllCartProducts();
        },
        csSetRightSidebarDealerData(appointment_data) {
          const dealer = this.localDealersList.find(dealerItem => dealerItem.id === appointment_data.dealer_id);
          this.csSetName('( '+ dealer.company_name + ' ) '+dealer.dealer_first_name + dealer.dealer_last_name);
          this.csSetEmail(dealer.dealer_email);
          this.csSetPhone(dealer.contact_number);
          this.csSetAddress(dealer.address_line_1 + ' ' + (dealer.address_line_2 || ''));
          this.csSetCity(dealer.city);
          this.csSetDate(null);
          this.csSetTime(null);
          this.csSetDealerId(appointment_data.dealer_id)
          this.csSetTimeSlots(dealer.time_slots)
          this.csSaveDealerToLocalStorage();
          this.csSetIsWithService(true);
          this.setSelectedServicePoint(dealer);
          localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(dealer));
        },
          /**
          * When the location found
          * @param {Object} addressData Data of the found location
          * @param {Object} placeResultData PlaceResult object
          * @param {String} id Input container ID
          */
          getAddressData(addressData, placeResultData, id) {
            this.tempAddress = placeResultData
            this.address = JSON.stringify(addressData);
            this.setTempAddress(this.address)
            this.setCtPlaceResultData(placeResultData);

            localStorage.setItem('address', this.address)
            localStorage.setItem('ctPlaceResultData', JSON.stringify(placeResultData))
            localStorage.setItem('tempAddress', placeResultData.formatted_address)

            /*For Homepage and Productlist Page*/
            localStorage.setItem('GoogleAddress', JSON.stringify(addressData))
            localStorage.setItem('GoogleSelectedPlace', JSON.stringify(placeResultData))
          },
          nextAvailableSlotDate(dealerService) {
              let days = this.availableSlotDay(dealerService)
              const now = new Date()
              const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
              const minDate = today
              let weekdays = [];
              if (this.currentLang != 'en_GB') {
                  weekdays = [
                      'Sunnuntai',
                      'Maanantai',
                      'Tiistai',
                      'Keskiviikko',
                      'Torstai',
                      'Perjantai',
                      'Lauantai'
                  ];
              } else {
                  weekdays = [
                      'Sunday',
                      'Monday',
                      'Tuesday',
                      'Wednesday',
                      'Thursday',
                      'Friday',
                      'Saturday'
                  ];
              }
              let count = 0, length = dealerService.min_skip_day + 2, month, dm, tempDate; /* By default length was  : 4 */
              // Order Monday first possibility to booking time on Thrusday
              // Order Tuesday first possibility to booking time on Friday
              // Order Wednesday first possibility to book time on Monday
              // Order Thursday first possibility to book time on Tuesday
              // Order Friday first possibility to book time on Wednesday
              // Order weekend first possibility to book time on Wednesday
              // Order public holiday first possibility to book time on 3th working day
              for (let i=1; i<length; i++) {
                  minDate.setDate(minDate.getDate() + 1)
                  // check for weekend
                  while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                      minDate.setDate(minDate.getDate() + 1)
                      // check for holiday
                      while (this.holidays.includes(tempDate)) {
                          minDate.setDate(minDate.getDate() + 1)
                          month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                          dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                          tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                      }
                  }
                  month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                  dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                  tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                  // check for holiday
                  while (this.holidays.includes(tempDate)) {
                      minDate.setDate(minDate.getDate() + 1)
                      // check for weekend
                      while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                          minDate.setDate(minDate.getDate() + 1)
                      }
                      month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                      dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                      tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                  }
              }

              if (!this.appointmentDate || this.appointmentDate == null) {
                  let month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                  let dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                  this.appointmentDate = minDate.getFullYear() + '-' + month + '-' + dm
              }

              let defaultAllowedTimes = []
              for(let timeSlot in dealerService.time_slots) {
                  let day = dealerService.time_slots[timeSlot].day
                  defaultAllowedTimes[day] = []
                  defaultAllowedTimes[day]['slots'] = []
                  defaultAllowedTimes[day]['start_time'] = dealerService.time_slots[timeSlot].start_time
                  defaultAllowedTimes[day]['end_time'] = dealerService.time_slots[timeSlot].end_time
                  let start = defaultAllowedTimes[day]['start_time'].split(':')
                  let end = defaultAllowedTimes[day]['end_time'].split(':')
                  let i=start[0];
                  for(i=parseInt(start[0]);i<=parseInt(end[0]);i++) {
                      let hour = i
                      if(i<10) {
                          hour = "0"+i
                      }
                      if(parseInt(start[1]) >= parseInt("00")
                          &&  parseInt(start[1]) < parseInt("30")) {
                          defaultAllowedTimes[day]['slots'].push(hour +':'+ '00')
                      }
                      if( i < parseInt(end[0]) ||
                      (parseInt(end[0]) == i && parseInt(end[1])>=parseInt("30"))) {
                          defaultAllowedTimes[day]['slots'].push(hour +':'+ '30')
                      }
                  }
              }

              let nextTimeSlot = '';
              if (defaultAllowedTimes[weekdays[minDate.getDay()]]['slots'][0]) {
                  nextTimeSlot = defaultAllowedTimes[weekdays[minDate.getDay()]]['slots'][0];
              }

              //this.allowedTimeOptions = this.getAllowedTimes(this.allowedTimes, this.appointmentDate)
              return minDate.getDate() + '-' + (minDate.getMonth()+1) + '-' + minDate.getFullYear() + ' ' + nextTimeSlot;
          },
          sortDealers(by){
              this.sortDirection = by.sortDirection;
              this.sortBy = by.sortBy;

              switch (this.sortBy){
                  case 'company_name':
                      this.sortDealresByName();
                  break;
                  case 'price':
                      this.sortDealresByServicePrice();
                  break;
                  case 'distance_km':
                      this.sortDealresByDistance();
                  break;
              }
              this.moveFirstSelectedDealer();
          },
          sortDealresByName() {
              this.localDealersList.sort(function (a, b){
                  if (this.sortDirection == 'Asc'){
                      return ((a.company_name == b.company_name) ? 0 : ((a.company_name > b.company_name) ? 1 : -1));
                  }

                  if (this.sortDirection == 'Desc'){
                      return ((a.company_name == b.company_name) ? 0 : ((a.company_name < b.company_name) ? 1 : -1));
                  }
              }.bind(this));
          },
          sortDealresByDistance() {
              this.localDealersList.sort(function(a, b){
                  if (this.sortDirection == 'Asc') {
                      return parseInt( a.distance_km ) > parseInt( b.distance_km ) ? 1 : -1;
                  }

                  if (this.sortDirection == 'Desc') {
                      return parseInt( a.distance_km ) < parseInt( b.distance_km ) ? 1 : -1;
                  }
              }.bind(this));
          },
          sortDealresByServicePrice() {
              this.localDealersList.sort(function(a, b){
                  if (this.sortDirection == 'Asc') {
                      return parseInt(this.dealerServicesSum(a.services, 'price')) > parseInt(this.dealerServicesSum(b.services, 'price')) ? 1 : -1;
                  }

                  if (this.sortDirection == 'Desc') {
                      return parseInt(this.dealerServicesSum(a.services, 'price')) < parseInt(this.dealerServicesSum(b.services, 'price')) ? 1 : -1;
                  }
              }.bind(this));
          },
          filterDealersByWorkingdays(selectedWorkingDay) {
              if (selectedWorkingDay.length == 0) {
                  this.localDealersList = this.dealerServiceList
              } else {
                  this.localDealersList = []
                  this.dealerServiceList.forEach((dealer) => {
                      let wdCount = 0;
                      dealer.time_slots.forEach((slot) => {
                          this.selectedWorkingDay.forEach((day) => {
                              if (slot.day_id == day.id && slot.is_active == '1') {
                                  wdCount++;
                              }
                          });
                      });
                      if (dealer.time_slots.length == wdCount && this.selectedWorkingDay.length == wdCount) {
                          this.localDealersList.push(dealer);
                      }
                  });
                  this.sortDealers(this.sortSelected);
              }
          },
          async getDealerServices(lang = "") {
              if (!("address" in localStorage || "GoogleAddress" in localStorage)) {
                this.localDealersList = [];
                return;
              }
              if(this.cartProducts.length > 0) {
                  let params= '';
                  if (this.dealerServiceApiParamsCached != null && this.dealerServiceApiParamsCached.length > 0 && !this.address) {
                      params = this.dealerServiceApiParamsCached

                      await this.fetchDealerServices(params)
                              .then(() => {
                                  this.localDealersList = this.dealerServiceList
                                  // this.filterDealersByWorkingdays(this.selectedWorkingDay)
                              })
                              .catch(() => {});
                      this.setDealerServiceApiParamsCached(params)
                  } else {
                      let addressCoordinates = JSON.parse(this.address)
                      if(addressCoordinates && addressCoordinates.latitude) {
                          params = 'latitude=' + addressCoordinates.latitude
                      }
                      if(addressCoordinates && addressCoordinates.longitude) {
                          params = params + '&longitude=' + parseFloat(addressCoordinates.longitude).toFixed(8)
                      }
                      if(this.services && this.services.length) {

                          if (this.paymentStatus == "failed") {
                              this.services = '['+this.services+']'
                          }

                          params = params + '&service_ids='+this.services
                      }
                      if(this.rimSizes && this.rimSizes.length) {
                          var rims = [];
                          this.rimSizes.forEach(function(part, index) {
                              let rim = part.split(':')
                              if(rim[1]) {
                                  rims[index] = rim[1];
                              }
                          }, rims);
                          params = params + '&rim_sizes='+ '[' + _.join(_.uniq(rims), [',']) + ']'
                      }
                      let locale_code = (this.currentLang == '') ? 'fi_FI' : this.currentLang
                      let locale_id = (locale_code == 'en_GB') ? 1 : 2
                      params = params + '&locale_id='+ locale_id
                      params = params + '&with=["timeSlots","workingDays"]'

                      if (addressCoordinates.latitude && addressCoordinates.longitude) {
                          await this.fetchDealerServices(params)
                              .then(() => {
                                  this.localDealersList = this.dealerServiceList
                                  // this.filterDealersByWorkingdays(this.selectedWorkingDay)
                              })
                              .catch(() => {});

                          localStorage.setItem('setDealerServiceApiParamsCached', params);

                          this.setDealerServiceApiParamsCached(params)
                      }
                  }

                  this.setSearchedZipcode(this.address);

                  localStorage.setItem("setSearchedZipcode", this.address)

                  this.showServices = true;

                  if (this.tempAddress && this.tempAddress.address_components) {
                      localStorage.setItem("tempAddress", this.tempAddress.formatted_address)
                      this.setStrAddress(this.tempAddress.formatted_address)
                      this.isVisibleSearchTag = true;
                  }
              }

          },
          showAvailableSlots(dealerservice) {
              let availableDays = [];
              if(dealerservice.time_slots) {
                  for(let availableDay in dealerservice.time_slots) {
                      availableDays[availableDay] =_.upperFirst(dealerservice.time_slots[availableDay].day)
                  }
                  return _.join(availableDays, ', ')
              }
          },
          formatPrice(price) {
              let format = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price)
              return format;
          },
          rimSize(rim) {
              if(rim) {
                  return rim + ' ' + this.$t("Inch")
              }
          },
          availableSlotDay(dealerservice) {
              let availableDays = this.showAvailableSlots(dealerservice)
              let days = []
              if(availableDays) {
                  days  = availableDays.split(', ');
              }
              return days;
          },
          showAppointment(index, dealerservice) {
              this.loadAppointments = true;
              this.showModal = true;

              localStorage.setItem("dealerservice", JSON.stringify(dealerservice))

              this.dealerService = dealerservice;
          },
          updateAllowedTime(dealerservice) {
              this.$nextTick(() => {})
              let defaultAllowedTimes = []
              let startTime = ''
              let endTime = '23:30'
              let unavailableTimeSlots = []
              let weekdays = [];
              if(this.currentLang!='en_GB') {
                  weekdays = [
                      'Sunnuntai',
                      'Maanantai',
                      'Tiistai',
                      'Keskiviikko',
                      'Torstai',
                      'Perjantai',
                      'Lauantai'
                  ];
              }
              else{
                  weekdays = [
                      'Sunday',
                      'Monday',
                      'Tuesday',
                      'Wednesday',
                      'Thursday',
                      'Friday',
                      'Saturday'
                  ];
              }

              // this.getUnavailableSlotList(dealerservice.dealer_id)
              // .then((response) => {
              //     if(this.unavailableSlots) {
              //         unavailableTimeSlots= []
              //         for(let slot in this.unavailableSlots) {
              //             let scheduleDate = this.unavailableSlots[slot].schedule_date
              //             if(_.indexOf(_.keys(unavailableTimeSlots), scheduleDate)===-1){
              //                 unavailableTimeSlots[scheduleDate] = []
              //             }
              //             unavailableTimeSlots[scheduleDate].push(this.unavailableSlots[slot].start_time)
              //         }
              //         defaultAllowedTimes['unavailableSlots'] = unavailableTimeSlots
              //     }
              //     for(let timeSlot in dealerservice.time_slots) {
              //         let day = dealerservice.time_slots[timeSlot].day
              //         defaultAllowedTimes[day] = []
              //         defaultAllowedTimes[day]['slots'] = []
              //         defaultAllowedTimes[day]['start_time'] = dealerservice.time_slots[timeSlot].start_time
              //         defaultAllowedTimes[day]['end_time'] = dealerservice.time_slots[timeSlot].end_time
              //         let start = defaultAllowedTimes[day]['start_time'].split(':')
              //         let end = defaultAllowedTimes[day]['end_time'].split(':')
              //         let i=start[0];
              //         for(i=parseInt(start[0]);i<=parseInt(end[0]);i++) {
              //             let hour = i
              //             if(i<10) {
              //                 hour = "0"+i
              //             }
              //             if(parseInt(start[1]) >= parseInt("00")
              //                 &&  parseInt(start[1]) < parseInt("30")) {
              //                 defaultAllowedTimes[day]['slots'].push(hour +':'+ '00')
              //             }
              //             if( i < parseInt(end[0]) ||
              //             (parseInt(end[0]) == i && parseInt(end[1])>=parseInt("30"))) {
              //                 defaultAllowedTimes[day]['slots'].push(hour +':'+ '30')
              //             }
              //         }
              //     }
              // })
              this.loadAppointments = false;
              return defaultAllowedTimes
          },
          getAllowedTimes(dealerservice) {
              let defaultAllowedTimes = []
              let startTime = ''
              let endTime = '23:30'
              let unavailableTimeSlots = []
              let minTime = ''
              let maxTime = ''
              for(let timeSlot in dealerservice.time_slots){
                  if(minTime.length=='' && maxTime.length=='') {
                      minTime = dealerservice.time_slots[timeSlot].start_time
                      maxTime = dealerservice.time_slots[timeSlot].end_time
                  } else {
                      let min = minTime.split(':')
                      let max = maxTime.split(':')
                      let slotStart = dealerservice.time_slots[timeSlot].start_time.split(':')
                      let slotEnd = dealerservice.time_slots[timeSlot].end_time.split(':')
                      if(parseInt(slotStart[0]) < parseInt(min[0]) && !isNaN(slotStart[0])) {
                          minTime = dealerservice.time_slots[timeSlot].start_time
                      }
                      if(parseInt(slotEnd[0]) > parseInt(max[0]) && !isNaN(slotEnd[0])) {
                          maxTime = dealerservice.time_slots[timeSlot].end_time
                      }
                  }
              }
              if(this.unavailableSlots) {
                  for(let slot in this.unavailableSlots) {
                      unavailableTimeSlots[slot] = this.unavailableSlots[slot].start_time
                  }
              }
              if(dealerservice.time_slots && minTime){
                  startTime = minTime
              }
              if(dealerservice.time_slots && maxTime){
                  endTime = maxTime
              }

              if(startTime.length > 0 ) {
                  let start = startTime.split(':')
                  let end = endTime.split(':')
                  let i=start[0];
                  for(i=parseInt(start[0]);i<=parseInt(end[0]);i++) {
                      let hr = i
                      if(i<10){
                          hr = "0"+i
                      }
                      if(_.indexOf(unavailableTimeSlots, hr+":00:00" )> 0) {
                          if(_.indexOf(unavailableTimeSlots, hr+':30:00') < 0) {
                              defaultAllowedTimes.push(i +':'+ '30')
                          }
                      } else {
                          if(parseInt(start[1]) >= parseInt("00")
                          &&  parseInt(start[1]) < parseInt("30")) {
                              defaultAllowedTimes.push(i +':'+ '00')
                              defaultAllowedTimes.push(i +':'+ '30')

                          } else {
                             defaultAllowedTimes.push(i +':'+ '30')
                          }
                      }
                  }
              }
              return defaultAllowedTimes
          },
          dealerServicesSum(items, prop){
              return items.reduce(function(a, b){
                  return parseFloat(a) + parseFloat(b[prop]);
              }, 0);
          },
          dealerServicesSums(services){
              let total = 0;
              services.forEach((service) => {
                  let isSingleCostAdded = false
                  this.cartProducts.forEach((product) => {
                      if (parseInt(product.diameter) == parseInt(service.rim_size) && service.is_price_per_quantity == '1' && service.has_variations == '1' && product.vehicle_type == service.vehicle_type) {
                          total += parseFloat(service.price) * parseInt(product.qty)
                      } else if (service.is_price_per_quantity == '0' && service.has_variations == '0' && !isSingleCostAdded) {
                          total += parseFloat(service.price)
                          isSingleCostAdded = true
                      }
                  })
              });
              return total;
          },
          serviceTotalCost(service){
              let total = 0;
              this.cartProducts.forEach((product) => {
                  if (parseInt(product.diameter) == parseInt(service.rim_size) && service.is_price_per_quantity == '1' && service.has_variations == '1' && product.vehicle_type == service.vehicle_type) {
                      total += parseFloat(service.price) * parseInt(product.qty)
                  }
              })
              return total;
          },
          removeAppointmentPopup()
          {
              this.showModal = false
              this.loadAppointments = false
              // $( '.modal-backdrop' ).remove();
          },
          distanceToLocation(distanceInKm)
          {
              let distance = 0
              distance = distanceInKm.toFixed(2).replace(".", ",")
              return distance
          },
          resetSearch() {
              this.$refs.autocomplete.clear()
              this.localDealersList = []
              this.isVisibleSearchTag = false
          },
          async goToUserInformation(){
              // // this.onReset();
              this.resetError();
              await this.confirmOrderWithPaytrail({}).then(() => {
                this.getAllCartProducts();
                this.$router.push({
                  path: '/cart/user-info', params: {}, replace: true
                });
              }).catch(() => {

              });

          },
          moveFirstSelectedDealer() {
            var services = this.localDealersList, servicePoint = null;
            if ("SearchedSelectedServicePoint" in localStorage) {
              servicePoint = JSON.parse(localStorage.getItem("SearchedSelectedServicePoint"))
            } else if ("dealerservice" in localStorage) {
              servicePoint = JSON.parse(localStorage.getItem("dealerservice"))
            }
            if (servicePoint != null) {
              var selectedServicePoint = services.find(item => item.dealer_id === servicePoint.dealer_id)
              if (selectedServicePoint) {
                var selectedServicePointIndex = services.indexOf(selectedServicePoint)
                services.splice(selectedServicePointIndex, 1);
                services.unshift(selectedServicePoint)
              }
            }
            this.localDealersList = services;
          },
        clearSearchedServicePoint() {
          if(this.$refs.autocomplete.$el.value === '') {
            this.address = '';
            localStorage.removeItem('address')
            localStorage.removeItem('ctPlaceResultData')
            localStorage.removeItem('tempAddress')

            /*For Homepage and Productlist Page*/
            if ('GoogleAddress' in localStorage) {
              localStorage.removeItem('GoogleAddress')
              localStorage.removeItem('GoogleSelectedPlace')
            }
            this.setShowEmptyDealerMessage(false)
            this.setDealers([]);
          }
        }
      },
  }
  </script>